import { render, staticRenderFns } from "./ConTentOppo.vue?vue&type=template&id=2ea0c872&scoped=true"
import script from "./ConTentOppo.vue?vue&type=script&lang=js"
export * from "./ConTentOppo.vue?vue&type=script&lang=js"
import style0 from "./ConTentOppo.vue?vue&type=style&index=0&id=2ea0c872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea0c872",
  null
  
)

export default component.exports